import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { useHistory } from "react-router-dom";
import { Button, Form, Table } from "react-bootstrap";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import SelectFilter from "../../../reusableComponents/selectFilter";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import moment from "moment";
import BasicPagination from "../../../Pagination/Pagination";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import {
  ADD_REASON,
  DEPARTMENTAL_CODE,
} from "../../../../enums/SuperadminWalletEnum";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import isEmpty from "../../../../store/validation/is-Empty";
import {
  get_process_approved_departmental_wallet,
  update_api_for_rejected_approved_action,
} from "../../../../store/actions/SuperAdminActions/superAdminWalletAction";
import { SmallLoader } from "../../../Loader/SmallLoader";
import { SuperAdminDepartmentalWalletFilter } from "./SuperAdminDepartmentalWalletFilter";
import NoContent from "../../../reusableComponents/NoContentComponent";

function SuperAdminDepartmentalProcess(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const token = props.auth.user.accessToken;
  const [processOpen, processSetOpen] = useState(false);
  const processHandleOpen = () => {
    processSetOpen(true);
  };
  const processClose = () => {
    processSetOpen(false);
  };

  const [dateQuery, setDateQuery] = useState({
    startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);

  const handleBatchChange = (pageNo) => {
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  /****************************************
   * @DESC PENDING WALLET API ACTION CALL
   ****************************************/
  const [walletData, setWalletData] = useState([]);
  useEffect(() => {
    dispatch(
      get_process_approved_departmental_wallet(
        token,
        dateQuery.startDate,
        dateQuery.endDate
      )
    );
  }, []);

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      dispatch(
        get_process_approved_departmental_wallet(
          token,
          dateQuery.startDate,
          dateQuery.endDate
        )
      );
    }
  }, [dateQuery]);

  useEffect(() => {
    if (!isEmpty(props.getProcessApprovedData)) {
      setWalletData(props.getProcessApprovedData);
    } else {
      setWalletData(props.getProcessApprovedData);
    }
  }, [props.getProcessApprovedData]);

  /****************************************
   * @DESC APPROVED WALLET API ACTION CALL
   ****************************************/
  const onClickProcessApproved = (id) => () => {
    const formData = {
      process: true,
    };
    dispatch(
      update_api_for_rejected_approved_action(
        token,
        formData,
        id,
        onSuccessApprovedUpdate
      )
    );
  };

  const onSuccessApprovedUpdate = () => {
    processClose();
    history.push("/superadmin/departmentwallet");
  };

  const [addReason, setAddReason] = useState("All");
  const [addDepartmentalCode, setDepartmentalCode] = useState("All");
  // const [selectDate, setSelectDate] = useState("");
  const [filter, showFilter] = useState(false);
  const [stateOne, setStateOne] = useState({
    search: "",
    anchorEl: null,
    restaurantReverse: "",
    showFilter: false,
    addReasonText: "All",
    addDepartmentalCodeText: "All",
  });

  /*********************************
   * @DESC Search Bar Action
   *********************************/
  const onSearchChange = (e) => {
    setStateOne({
      ...stateOne,
      search: e.target.value,
    });
  };

  const onFilterSave = (e) => {
    setStateOne({
      ...stateOne,
      addReasonText: addReason,
      addDepartmentalCodeText: addDepartmentalCode,
      // addSelectDateText: selectDate,
    });
    showFilter(!filter);
  };

  const onChangeAddReason = (e) => {
    setAddReason(e.target.value);
  };
  const onChangeDepartmentType = (e) => {
    setDepartmentalCode(e.target.value);
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const handleClick = (event) => {
    setStateOne({
      ...stateOne,
      anchorEl: event.currentTarget,
    });
  };

  const handleCloseOne = () => {
    setStateOne({
      ...stateOne,
      anchorEl: null,
    });
  };

  const handleSelect = (value) => () => {
    setStateOne({
      ...stateOne,
      restaurantReverse: value,
      anchorEl: false,
    });
  };

  /*****************************************
   * @DESC Download Button Action
   ****************************************/
  const downloadData = {
    headers: [
      { label: "Transaction Id", key: "transactionId" },
      { label: "Department Code", key: "departmentcode" },
      { label: "Reason", key: "reason" },
      { label: "Comments", key: "comments" },
      { label: "Request Date & Time", key: "requestDateTime" },
      { label: "Amount", key: "amount" },
      { label: "Status", key: "status" },
    ],
    data: walletData.map((ele) => {
      return {
        transactionId: ele?._id,
        departmentcode: ele?.departmentalCode,
        reason: ele?.reason,
        comments: ele?.message,
        requestDateTime: `${moment(ele?.createdAt).format("ll")}`,
        amount: ele?.amount,
        status: ele?.status,
      };
    }),
  };

  let filterData = [];
  if (
    stateOne.restaurantReverse === "" &&
    stateOne.addDepartmentalCodeText === "All" &&
    stateOne.addReasonText === "All"
  ) {
    filterData = walletData;
  }
  if (stateOne.addDepartmentalCodeText !== "All") {
    filterData = walletData.filter((data) => {
      if (data.departmentalCode === stateOne.addDepartmentalCodeText) {
        return data;
      } else {
        return false;
      }
    });
  }
  if (stateOne.addReasonText !== "All") {
    filterData = walletData.filter((data) => {
      if (data.reason === stateOne.addReasonText) {
        return data;
      } else {
        return false;
      }
    });
  }
  if (stateOne.restaurantReverse === "A-Z") {
    filterData = walletData.sort((a, b) => {
      if (a?.amount < b?.amount) return -1;
      if (a?.amount > b?.amount) return 1;
      return 0;
    });
  } else if (stateOne.restaurantReverse === "Z-A") {
    filterData = walletData.sort((a, b) => {
      if (a?.amount < b?.amount) return 1;
      if (a?.amount > b?.amount) return -1;
      return 0;
    });
  }
  if (stateOne.search) {
    let search = new RegExp(stateOne.search, "i");
    filterData = walletData.filter((getall) => {
      if (search.test(getall?.departmentalCode)) {
        return getall;
      } else if (search.test(getall?.reason)) {
        return getall;
      } else if (search.test(getall?.amount)) {
        return getall;
      } else {
        return false;
      }
    });
  }

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Departmental Wallet Approved Requests
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    name="search"
                    onChange={onSearchChange}
                    value={stateOne.search}
                    className="amSearch"
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler} />
                  </div>
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <SortComponent
                      handleClick={handleClick}
                      anchorEl={stateOne.anchorEl}
                      handleClose={handleCloseOne}
                      selectClick={(data) => handleSelect(data)}
                    />
                    <div
                      className="f10-400"
                      align="center"
                      onClick={() => showFilter(!filter)}
                    >
                      <img
                        src={require("../../../../assets/images/iconButton/filtericon.png")}
                        width="35px"
                      />
                      <br />
                      Filter
                    </div>
                    <CSVDownloader
                      filename={"Departmental Wallet Approved Request"}
                      headers={downloadData.headers}
                      data={downloadData.data}
                    />
                  </div>
                </div>
              </div>
              <div>
                <SuperAdminDepartmentalWalletFilter
                  filter={filter}
                  addReason={addReason}
                  addDepartmentalCode={addDepartmentalCode}
                  onChangeDepartmentType={(e) => onChangeDepartmentType(e)}
                  onChangeAddReason={(e) => onChangeAddReason(e)}
                  showFilter={() => showFilter(!filter)}
                  onFilterSave={onFilterSave}
                />
                <div className="col-12 p-0 user-table-reusable-superadmin">
                  <Table className="HideShowTable enMinWidth900">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "14%" }} className="f12-700">
                          Transaction ID
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Department Code
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Add Reason
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Comments
                        </th>
                        <th style={{ width: "13%" }} className="f12-700">
                          Date & Time
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Amount
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Status
                        </th>
                        <th style={{ width: "13%" }} className="f12-700">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    {props.auth.secondary_loader ? (
                      <SmallLoader />
                    ) : (
                      !isEmpty(filterData) ?
                      filterData.slice(start, end).map((data, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tbody>
                              <tr
                                // className="super_admin_all_users_table_body"
                                style={{
                                  lineBreak: "anywhere",
                                  backgroundColor: "#FFFFFF",
                                  borderRadius: "10px",
                                  boxShadow: "0px 3px 6px #00000014",
                                  padding: "10px 0px",
                                }}
                              >
                                <td
                                  style={{ width: "14%" }}
                                  className="f12-400"
                                >
                                  {data._id}
                                </td>
                                <td
                                  style={{ width: "10%" }}
                                  className="f12-400"
                                >
                                  {data.departmentalCode}
                                </td>
                                <td
                                  style={{ width: "15%" }}
                                  className="f12-400"
                                >
                                  {data.reason}
                                </td>
                                <td
                                  style={{ width: "15%" }}
                                  className="f12-400"
                                >
                                  {data.message}
                                </td>
                                <td
                                  style={{ width: "13%" }}
                                  className="f12-400"
                                >
                                  {moment(data.createdAt).format(
                                    "Do MMM, YYYY"
                                  )}{" "}
                                  <br />
                                  {moment(data.createdAt).format("hh:mm A")}
                                </td>
                                <td
                                  style={{ width: "10%" }}
                                  className="f12-500"
                                >
                                  ₹ {data.amount}
                                </td>
                                <td
                                  style={{ width: "10%" }}
                                  className="f12-400"
                                >
                                  {data.status === "APPROVED" ? (
                                    <div
                                      className="badge badge-success px-3 py-2"
                                      style={{
                                        borderRadius: "20px",
                                        color: "#fff",
                                      }}
                                    >
                                      {data.status}
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td
                                  style={{ width: "13%" }}
                                  className="f12-400"
                                >
                                  <div className="d-flex align-items-center">
                                    <ApprovedWalletRequest
                                      openModal={processOpen}
                                      handleOpenModal={processHandleOpen}
                                      handleClosedModal={processClose}
                                      handleApproved={onClickProcessApproved(
                                        data._id
                                      )}
                                    />
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </React.Fragment>
                        );
                      }):<NoContent/>
                    )}
                  </Table>
                </div>
                {stateOne.search !== "" ? (
                  ""
                ) : (
                  <div className="row">
                    <div className="col-12">
                      {filterData.length !== 0 ? (
                        <BasicPagination
                          totalRecords={filterData.length}
                          limit={10}
                          batch={page}
                          onBatchChange={(e) => handleBatchChange(e)}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

SuperAdminDepartmentalProcess.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  get_process_approved_departmental_wallet: PropTypes.func.isRequired,
  update_api_for_rejected_approved_action: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  getProcessApprovedData:
    state.superAdminWallet.get_all_departmental_process_approved,
});

export default connect(mapStateToProps, {
  get_process_approved_departmental_wallet,
  update_api_for_rejected_approved_action,
})(withRouter(SuperAdminDepartmentalProcess));

export function ApprovedWalletRequest(props) {
  return (
    <div>
      <Button
        variant="danger"
        className="btn f12-400"
        style={{
          width: "100px",
          height: "35px",
          backgroundColor: "#EE3A23",
          color: "#fff",
          borderRadius: "4px",
          fontSize: "14px",
          fontWeight: 500,
        }}
        onClick={props.handleOpenModal}
      >
        Process
      </Button>
      <Dialog
        open={props.openModal}
        onClose={props.handleClosedModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Request Approve</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="f12-500">
              Are you sure you want to approve this request?
            </div>
          </DialogContentText>
        </DialogContent>
        <div className="col-12 mb-3">
          <DialogActions>
            <Button
              variant="outline-secondary"
              className="btn-md mr-4 px-5"
              onClick={props.handleClosedModal}
            >
              No
            </Button>
            <Button
              variant="danger"
              className="btn-md px-5"
              onClick={props.handleApproved}
            >
              Yes
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
}
